import { FirmBusinessCardsView } from "@/components/features/settings/firm/FirmBusinessCardsView";
import { Typography } from "@/components/ui";

export default function FirmBusinessCardsCard() {
  return (
    <div className="w-full">
      <div className="mb-6 ml-2 gap-y-1">
        <Typography color="primary" variant="heading">
          Business cards
        </Typography>
      </div>
      <FirmBusinessCardsView />
    </div>
  );
}
